import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';

export enum GbpUpdateType {
  LOCATION_DATA = 'LOCATION_DATA',
  MEDIA = 'MEDIA',
  PLACE_ACTION_LINKS = 'PLACE_ACTION_LINKS',
  SOCIAL_MEDIA_LINKS = 'SOCIAL_MEDIA_LINKS',
  LOCATION_GROUPS = 'LOCATION_GROUPS',
  AUTO_CONNECT = 'AUTO_CONNECT'
}

@Component({
    selector: 'app-get-gbp-updates-popup',
    templateUrl: './get-gbp-updates-popup.component.html',
    styleUrls: ['./get-gbp-updates-popup.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        MatIcon,
        MatDialogContent,
        MatCheckbox,
        MatDivider,
        FormsModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class GetGbpUpdatesPopupComponent {

  allSelected: boolean = false;

  selection: { id, selected, displayedText }[] = [
    {
      id: GbpUpdateType.LOCATION_DATA,
      selected: true,
      displayedText: 'Get latest location data (e.g. Business name, Address)',
    },
    {
      id: GbpUpdateType.MEDIA,
      selected: true,
      displayedText: 'Get latest media data (e.g. Cover photo)',
    },
    {
      id: GbpUpdateType.PLACE_ACTION_LINKS,
      selected: false,
      displayedText: 'Get latest place action link data (e.g. Appointment URL)',
    },
    {
      id: GbpUpdateType.SOCIAL_MEDIA_LINKS,
      selected: false,
      displayedText: 'Get latest social media link data (e.g. Facebook URL)',
    },
    {
      id: GbpUpdateType.LOCATION_GROUPS,
      selected: false,
      displayedText: 'Get latest GBP location group data',
    },
    {
      id: GbpUpdateType.AUTO_CONNECT,
      selected: false,
      displayedText: 'Auto-connect GBP locations',
    },
  ];

  constructor() {
  }

  nothingSelected(): boolean {
    return this.selection.filter(s => s.selected)?.length === 0;
  }

  someSelected(): boolean {
    return !!this.selection?.find(s => s.selected) && !this.allSelected;
  }

  updateMasterToggleState() {
    this.allSelected = this.selection?.every(s => s.selected);
  }

  onMasterToggleClicked(selected: boolean) {
    this.allSelected = selected;
    this.selection?.forEach(s => (s.selected = selected));
  }

  generateResult(): GbpUpdateType[] {
    return this.selection.filter(s => s.selected).map(s => s.id);
  }

}
